import React from 'react';
import {ICONS} from '../../Constants/Icons';
import ToolTipViewBtn from '../../Component/ToolTipViewBtn';
import Tooltip from '../../Component/Tooltip';
import {useLocale} from '../../Localization/LocaleContext';

const TextInput = ({
  current_data,
  update_data,
  title,
  note,
  id,
  placeholder,
  type,
  isRequired,
  input_box_style,
  component_style,
  isDisabled,
  title_style,
  field_style,
  tooltip,
  onFocus,
  autoCapitalize,
}) => {
  const {translate} = useLocale();
  return (
    <div className={['space-y-1  w-full ', component_style].join(' ')}>
      {title && (
        <div className="flex items-center gap-1">
          <p
            className={[
              'text-gray-600',
              isRequired &&
                "flex-none relative after:content-['*'] after:text-red-500 after:-top-[5px] after:-right-[12px] ",
            ].join(' ')}
            style={title_style}>
            {translate(title)}
          </p>
          {tooltip && <Tooltip title={translate(title)} description={translate(tooltip)} />}
        </div>
      )}
      <input
        id={id}
        key={id}
        value={current_data}
        className={['form-input py-2 w-full', input_box_style].join(' ')}
        style={field_style}
        type={type ?? 'text'}
        autoCapitalize={autoCapitalize}
        onFocus={onFocus}
        onChange={e => {
          update_data(e.target.value);
        }}
        placeholder={translate(placeholder)}
        disabled={isDisabled}
      />
      {note && <p className="text-xs mt-2 italic">{translate(note)}</p>}
    </div>
  );
};

export default TextInput;
